(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ummah-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ummah-faq-list')) return;

    class UmmahFaqList extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;
        const details = summary.parentElement;
        const panel = details.querySelector('.ummah-faq__answer');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!panel || reduce || typeof panel.animate !== 'function') return;

        // Opening only: fade/translate the answer in (transform + opacity, no height animation / layout thrash).
        if (details.open) return;
        event.preventDefault();
        details.open = true;
        panel.animate(
          [{ opacity: 0, transform: 'translate3d(0,-8px,0)' }, { opacity: 1, transform: 'none' }],
          { duration: 420, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' }
        );
      }
    }

    customElements.define('ummah-faq-list', UmmahFaqList);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ummah-gifting"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) return;
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('[data-ummah-gifting] .ummah-gifting__card');
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ummah-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mqDesktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

    function init(root) {
      if (root.dataset.uhInit) return;
      root.dataset.uhInit = '1';
      var intensity = root.dataset.intensity;
      var reduce = mqReduce.matches;

      /* Video: never autoplays from markup; only started here when motion is allowed. */
      var video = root.querySelector('[data-uh-video]');
      if (video) {
        var markPlaying = function () { video.classList.add('is-playing'); };
        video.addEventListener('playing', markPlaying);
        var toggle = root.querySelector('[data-uh-toggle]');
        var userPaused = false;
        var tryPlay = function () {
          var off = mqReduce.matches || intensity === 'off';
          if (toggle) {
            toggle.hidden = off;
            toggle.setAttribute('aria-label', userPaused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
          }
          root.classList.toggle('is-paused', userPaused);
          if (off || userPaused) { video.pause(); video.classList.remove('is-playing'); return; }
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        };
        if (toggle) toggle.addEventListener('click', function () { userPaused = !userPaused; tryPlay(); });
        tryPlay();
        if (mqReduce.addEventListener) mqReduce.addEventListener('change', tryPlay);
      }

      /* Depth parallax: desktop + fine pointer only, never under reduced motion or intensity off. */
      if (reduce || intensity === 'off' || !mqDesktop.matches) return;
      var layers = Array.prototype.slice.call(root.querySelectorAll('[data-uh-depth]'));
      if (!layers.length) return;
      var factor = intensity === 'rich' ? 1 : 0.55;
      var visible = true, ticking = false, px = 0, py = 0, sy = 0;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(root);
      }
      function render() {
        ticking = false;
        layers.forEach(function (l) {
          var d = parseFloat(l.dataset.uhDepth) * factor;
          var x = px * d * 120;
          var y = sy * d + py * d * 80;
          l.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
        });
      }
      function queue() { if (visible && !ticking) { ticking = true; requestAnimationFrame(render); } }
      window.addEventListener('scroll', function () {
        sy = Math.min(window.scrollY, window.innerHeight * 1.2);
        queue();
      }, { passive: true });
      root.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect();
        px = (e.clientX - r.left) / r.width - 0.5;
        py = (e.clientY - r.top) / r.height - 0.5;
        queue();
      }, { passive: true });
      root.addEventListener('pointerleave', function () { px = 0; py = 0; queue(); });
    }
    function scan() { document.querySelectorAll('[data-ummah-hero]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ummah-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var steps = root.querySelectorAll('.ummah-showcase__step');
      var slides = root.querySelectorAll('.ummah-showcase__slide');
      function activate(i) {
        steps.forEach(function (s) { s.classList.toggle('is-active', s.dataset.index === i); });
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.index === i); });
      }
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) activate(e.target.dataset.index); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) {
        io.observe(s);
        s.addEventListener('focusin', function () { activate(s.dataset.index); });
      });
    }
    function run() { document.querySelectorAll('[data-ummah-showcase]').forEach(init); }
    run();
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:block:select', function (e) {
      var step = e.target.closest && e.target.closest('.ummah-showcase__step');
      if (step) step.scrollIntoView({ block: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ummah-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!('IntersectionObserver' in window) || root.classList.contains('is-armed')) return;
      root.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      root.querySelectorAll('[data-ummah-reveal]').forEach(function (el, i) {
        el.style.transitionDelay = (i * 80) + 'ms';
        io.observe(el);
      });
    }
    function run() { document.querySelectorAll('.ummah-story').forEach(init); }
    run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
